export enum Position {
  STICKY = 'sticky',
  RELATIVE = 'relative',
}
